export default {
  getUserId(state) {
    return state.user;
  },
  getOrdersByStatus: (state) => (check) => {
    const list = state.orders.filter((item) => item.check === check);
    return list;
  },
};
